var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[_c('div',{staticClass:"content"},[_c('object',{staticClass:"pdfviewer",attrs:{"type":"application/pdf","data":_vm.resource.file.filename}},[_c('p',[_vm._v("The PDF cannot be displayed.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }